import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardProps, EntityStack } from '@shapeable/ui';
import { FeedEntry } from '@shapeable/kelp-forest-alliance-types';

const cls = classNames('feed-entry-cards');

// -------- Types -------->

// -------- Props -------->

export type FeedEntryCardProps = EntityCardProps & { 
  entity?: FeedEntry;
};

export const FeedEntryCardDefaultProps: Omit<FeedEntryCardProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});


// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    Meta: styled(EntityStack)``,
};

export const FeedEntryCard: Shapeable.FC<FeedEntryCardProps> = (props) => {
  const { className, children, entity } = props;
  
  const { people = [] } = entity || {};

  return (
    <My.Container 
      className={cls.name(className)} 
      entity={entity}
      labelDeriver={entity => entity?.types?.[0]?.name}
      >
      <My.Meta items={people} />
    </My.Container>
  )
};

FeedEntryCard.cls = cls;